import { Image } from 'antd';
import moment from 'moment';
import { memo } from 'react';
import { COLOR } from '../../utils/constants';
import { decrypt } from '../../utils/decrypt';

const Message = ({
  message,
  userId,
  openChangeColorModal,
  conversationDetail,
}) => {
  return message?.type === 'MESSAGE' ? (
    <p
      className={
        userId === message?.user?.id
          ? 'message sender-message'
          : 'message receiver-message'
      }
      onClick={(e) => {
        if (e.target.classList.contains('ant-image-mask')) return;
        openChangeColorModal();
      }}
      style={
        conversationDetail?.color
          ? { backgroundColor: COLOR[conversationDetail?.color] }
          : null
      }
    >
      <small style={{ textDecoration: 'italic' }}>
        <i>{message?.user?.fullName}</i>
      </small>
      <br />
      {decrypt(message?.content)}
      <span className="message-timestamp">
        {moment(message?.createdAt).format('lll')}
      </span>
    </p>
  ) : message?.type === 'INFO' ? (
    <p style={{ textAlign: 'center' }}>{decrypt(message?.content)}</p>
  ) : (
    <div
      className={
        userId === message?.user?.id
          ? 'message sender-message'
          : 'message receiver-message'
      }
      onClick={(e) => {
        if (e.target.classList.contains('ant-image-mask')) return;
        openChangeColorModal();
      }}
      style={
        conversationDetail?.color
          ? { backgroundColor: COLOR[conversationDetail?.color] }
          : null
      }
    >
      <Image
        width={200}
        src={message?.medias?.length > 0 ? message?.medias[0]?.imageUrl : ''}
        className={
          userId === message?.user?.id ? 'sender-message' : 'receiver-message'
        }
      />
      <span className="message-timestamp">
        {moment(message?.createdAt).format('lll')}
      </span>
    </div>
  );
};

export default memo(Message);
